import { FelaCSSWithCustomSelectors } from '@bridebook/ui';
import { ISharedTypes as IProps } from './custom-click-link';

interface IStyles {
  wrapper: FelaCSSWithCustomSelectors;
}

const styles = ({ underlined }: IProps): IStyles => {
  const hover = { textDecoration: underlined ? 'underline' : 'none' };

  return {
    wrapper: {
      display: 'flex',

      '> a': {
        color: 'inherit',

        ':hover': hover,
        ':active': hover,
        ':focus': hover,
        ':visite': hover,
      },
    },
  };
};

export default styles;
